"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleHookUseFilters = void 0;
const react_1 = __importDefault(require("react"));
const hooks_1 = require("../../hooks");
const components_1 = require("../../components");
const ExampleHookUseFilters = () => {
    var _a;
    const filtersHook = (0, hooks_1.useFilters)();
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h3", null, "Filters"), (_a = filtersHook.filters) === null || _a === void 0 ? void 0 :
        _a.map((filter) => (react_1.default.createElement("div", null,
            react_1.default.createElement("p", null, filter.name),
            react_1.default.createElement(components_1.Filter, { key: filter.id, filter: filter }))))));
};
exports.ExampleHookUseFilters = ExampleHookUseFilters;
//# sourceMappingURL=ExampleHookUseFilters.js.map